// Infrastructure
import fixtures from './fixtures.json';

// Domain
import { StateRepository } from '../../../domain/repository';
import { StateEntity } from '../../../domain/entities/state-entity';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class StateDummyRepository implements StateRepository {
  // eslint-disable-next-line class-methods-use-this
  execute(codpais: string): Promise<Array<StateEntity>> {
    return Promise.resolve(fixtures);
  }
}
